import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemTypeComponent } from 'src/app/components/system-type/system-type.component';
import { SystemTypeFinderComponent } from 'src/app/components/system-type-finder/system-type-finder.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProjectNameComponent } from 'src/app/components/project-name/project-name.component';
import { AddWindowComponent } from 'src/app/components/add-window/add-window.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatButtonModule, MatCardModule, MatExpansionModule, MatTabsModule, MatCheckboxModule } from '@angular/material';
import { WindowAccordionComponent } from 'src/app/components/window-accordion/window-accordion.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TotalConsumptionComponent } from 'src/app/components/total-consumption/total-consumption.component';
import { WindowExpansionPanelComponent } from 'src/app/components/window-expansion-panel/window-expansion-panel.component';
import { StandardWindowComponent } from 'src/app/components/standard-window/standard-window.component';
import { NonstandardWindowComponent } from 'src/app/components/nonstandard-window/nonstandard-window.component';
import { EdgeComponent } from 'src/app/components/edge/edge.component';
import { StandardEdgeComponent } from 'src/app/components/standard-edge/standard-edge.component';
import { YourSavingsComponent } from 'src/app/components/your-savings/your-savings.component';

@NgModule({
  declarations: [
    AddWindowComponent,
    SystemTypeComponent,
    SystemTypeFinderComponent,
    ProjectNameComponent,
    WindowAccordionComponent,
    TotalConsumptionComponent,
    WindowExpansionPanelComponent,
    StandardWindowComponent,
    NonstandardWindowComponent,
    EdgeComponent,
    StandardEdgeComponent,
    YourSavingsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    MatButtonModule,
    MatCardModule,
    MatExpansionModule,
    BrowserAnimationsModule,
    MatTabsModule,
    MatCheckboxModule,
  ],
  exports: [
    AddWindowComponent,
    SystemTypeComponent,
    SystemTypeFinderComponent,
    ProjectNameComponent,
    WindowAccordionComponent,
    TotalConsumptionComponent,
    WindowExpansionPanelComponent,
    StandardWindowComponent,
    NonstandardWindowComponent,
    EdgeComponent,
    StandardEdgeComponent,
    YourSavingsComponent
  ]
})
export class CalculatorModule { }
